import axios from "axios";

const registerDeviceToken = async (token) => {
  try {
    if (!token) {
      console.warn("⚠️ No FCM token provided, skipping registration");
      return;
    }

    // Send token to server (you can include location later if available)
    const body = { token, device: "android" }; // adjust device as needed
    await axios.post("/api/device-token/register", body, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });

    console.log("✅ Device token registered:", token);
  } catch (err) {
    console.error("❌ Failed to register device token:", err.message);
  }
};

export default registerDeviceToken;
